var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.108,
    height: 6.549,
    viewBox: "0 0 11.108 6.549",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow",
    transform: "translate(-138.322 -290.225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "expand_more_FILL1_wght400_GRAD0_opsz48_1_",
    "data-name": "expand_more_FILL1_wght400_GRAD0_opsz48 (1)",
    d: "M17.554,23.149,12,17.6l1-1,4.559,4.582,4.559-4.559,1,1Z",
    transform: "translate(126.322 273.625)",
    fill: "#86899b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.0262006ac35692134fbe291b729cd440.svg";
export { ForwardRef as ReactComponent };